import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Let’s get in touch!</h2>
                        </div>
                        <p>Grow your startup vision with TekRevol's Startup Prototype Development Services. Whether you are creating new ideas or refining present ones, we modernize the process with innovative solutions and a commitment to accuracy. Let's dive into your project requirements without needless complications. Fill out the form, click 'Connect,' and let's commence a journey toward realizing your startup's potential through impactful prototype development.</p>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;